// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__UZsvT","icon":"IconButton_icon__YFTzi","color-danger":"IconButton_color-danger__T0Mxz"};